import { OnInit, Directive } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormControlService } from './../../../../shared/services/form-control.service';
import { ApiService } from './../../../../shared/services/api.service';
import { AlertService } from './../../../../shared/services/alert.service';
import { FormEditor } from './../../../../models/editors/form-editor.base.model';

export const SUCCESS_MESSAGE = 'Uložení proběhlo úspěšně!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Directive()
export class InlineFormBase<T> implements OnInit {

    protected _id: string;
    public url: string;
    protected _saveCallback: Function;
    protected _fieldsConfig: Array<FormEditor<any>> = [];

    public entity: T;
    public form: FormGroup;

    public get fieldsConfig(): Array<FormEditor<any>> {
        return this._fieldsConfig;
    }

    public set fieldsConfig(fieldsConfig: Array<FormEditor<any>>) {
        this._fieldsConfig = fieldsConfig;
    }

    public formEditors: any;
    public isInitialized = false;
    public isSaving = false;
    public headerTitle: string;

    constructor(
        protected _formService: FormControlService,
        protected _apiService: ApiService,
        protected _alertService: AlertService
    ) { }

    public save() {
        this.form.updateValueAndValidity();
        if (this.form.valid) {
            this.isSaving = true;
            this._apiService.put(this.form.value, this.url + '/change').subscribe(
                (response: any) => {
                    if ({ ...response }.status <= 0) {
                        this._alertService.error(ERROR_MESSAGE);
                    } else {
                        if (this._saveCallback && typeof this._saveCallback === 'function') {
                            this._saveCallback(response);
                        }
                        this._alertService.success(SUCCESS_MESSAGE);
                    }
                    this.isSaving = false;
                },
                (error) => {
                    this._alertService.error(ERROR_MESSAGE);
                    this.isSaving = false;
                }
            );
        }
    }


    ngOnInit() {
        this._getEntity();
    }

    protected _setupForm(): void {
        this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
        this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
        console.log(this.form.value, this.entity);
    }

    protected _getEntity() {
        this._apiService.get(this.url)
            .subscribe(
                (response: any) => {
                    this.entity = { ...response }.data;
                    this._setupForm();
                    this.isInitialized = true;
                },
                (error) => console.error(error)
            );
    }
}
